<template>
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="showInfoTag(info)"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <template v-else-if="info.type === 'details'">
              <info-range-details
                :range_details="infoData.range_details"
                :model="infoData"
              />
            </template>
            <td
              :style="{
                wordBreak: 'auto-phrase',
                textAlign: 'justify',
              }"
              v-else-if="
                typeof info.visibility === 'undefined' ||
                Boolean(info.visibility)
              "
            >
              <h6 class="mb-1">
                <strong>{{ info.label }}:</strong>
              </h6>
              <span v-if="validateIsset(info.value)" class="mt-2">
                {{ info.value }}
              </span>
              <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                $t('common_words.no_assignment')
              }}</el-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import InfoRangeDetails from 'src/views/Pages/Dashboard/RangeColor/steps/InfoRangeDetails.vue';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';

export default {
  name: 'step-confirm',
  components: {
    [InfoRangeDetails.name]: InfoRangeDetails,
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.names'),
          value: this.infoData.name,
        },
        {
          label: i18n.t('common_words.modules'),
          value: this.infoData.modules_names,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.companies2'),
          value: this.infoData.businesses_names,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.color_range_details'),
          value: this.infoData.range_details,
          type: 'details',
        },
      ];
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    showInfoTag(info) {
      return (
        (typeof info.visibility === 'undefined' || Boolean(info.visibility)) &&
        this.validateIsset(info.value) &&
        Array.isArray(info.value) &&
        info.type !== 'details'
      );
    },
  },
};
</script>
